import { Link } from 'react-router-dom';
import { Construction } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function MaintenancePage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-background to-muted/50 px-4">
      <div className="mx-auto max-w-md text-center">
        {/* Icon */}
        <div className="mb-8 flex justify-center">
          <div className="rounded-full bg-primary/10 p-6">
            <Construction className="h-16 w-16 text-primary" />
          </div>
        </div>

        {/* Title */}
        <h1 className="font-display text-4xl font-bold tracking-tight text-foreground md:text-5xl">
          Sitio en Construcción
        </h1>

        {/* Description */}
        <p className="mt-4 text-lg text-muted-foreground">
          Estamos trabajando para ofrecerte el mejor contenido sobre sillas de escritorio y ergonomía.
          ¡Vuelve pronto!
        </p>

        {/* Admin login link */}
        <div className="mt-12">
          <Link to="/auth">
            <Button variant="ghost" size="sm" className="text-muted-foreground">
              Acceso administradores
            </Button>
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="absolute bottom-4 text-center text-sm text-muted-foreground">
        © {new Date().getFullYear()} Silla Ideal
      </footer>
    </div>
  );
}
